import { motion, useMotionValue, useSpring } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { usePlaceholder } from "../lib/usePlaceholder";
import { coreState } from "../lib/util";

const useMagnet = (strength = 0.25) => {
  const x = useMotionValue(0);
  const y = useMotionValue(0);
  const sx = useSpring(x, { stiffness: 220, damping: 16 });
  const sy = useSpring(y, { stiffness: 220, damping: 16 });
  const onMouseMove = (e) => {
    if (window.matchMedia("(pointer: coarse)").matches) return;
    const r = e.currentTarget.getBoundingClientRect();
    x.set((e.clientX - r.left - r.width / 2) * strength);
    y.set((e.clientY - r.top - r.height / 2) * strength * 1.3);
  };
  const reset = () => {
    x.set(0);
    y.set(0);
  };
  return { style: { x: sx, y: sy }, onMouseMove, reset };
};

export const PrimaryCTA = ({ children, linkKey = "consultation", testId, className = "" }) => {
  const ph = usePlaceholder(linkKey);
  const m = useMagnet();
  return (
    <motion.a
      {...ph}
      data-testid={testId}
      style={m.style}
      onMouseMove={m.onMouseMove}
      onMouseEnter={() => (coreState.glowTarget = 1)}
      onMouseLeave={() => {
        m.reset();
        coreState.glowTarget = 0;
      }}
      whileTap={{ scale: 0.97 }}
      className={`btn-primary group ${className}`}
    >
      <span className="relative z-10">{children}</span>
      <span className="relative z-10 grid h-8 w-8 place-items-center rounded-full bg-noor-deep text-noor-champagne transition-transform duration-500 group-hover:rotate-45 rtl:-scale-x-100">
        <ArrowUpRight size={16} strokeWidth={1.6} />
      </span>
    </motion.a>
  );
};

export const GhostCTA = ({ children, onClick, testId, tone = "dark", className = "" }) => {
  const m = useMagnet(0.18);
  const toneCls =
    tone === "dark"
      ? "border-noor-pearl/25 text-noor-pearl hover:bg-noor-pearl/[0.07] hover:border-noor-champagne/60"
      : "border-noor-emerald/30 text-noor-emerald hover:bg-noor-emerald/[0.06] hover:border-noor-emerald/60";
  return (
    <motion.button
      type="button"
      data-testid={testId}
      onClick={onClick}
      style={m.style}
      onMouseMove={m.onMouseMove}
      onMouseLeave={m.reset}
      whileTap={{ scale: 0.97 }}
      className={`inline-flex min-h-[52px] items-center gap-3 rounded-full border px-7 text-[15px] font-medium transition-[background-color,border-color] duration-500 ${toneCls} ${className}`}
    >
      {children}
    </motion.button>
  );
};
